import React from 'react';

//componets
import { MirandaBrandButton } from '@/components/Button';
// styles
import {
  HeroWrapper,
  HeroContainer,
  FlexRow,
  StyledTitle,
  StyledDescription,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroWrapper>
      <HeroContainer>
        <StyledTitle>
          Scale Smarter with 4PL <br />
          &amp; Managed Transportation
        </StyledTitle>
        <StyledDescription>
          Cut freight costs by up to 20% and scale logistics without growing
          your headcount. Loadsmart’s 4PL and Managed Transportation services
          flex with your needs—backed by expert teams and tech that adapt as you
          grow.
        </StyledDescription>
        <FlexRow>
          <MirandaBrandButton as="a" href="#hubspot-form">
            Schedule an assessment
          </MirandaBrandButton>
        </FlexRow>
      </HeroContainer>
    </HeroWrapper>
  );
}
